import './Profile.scss';
import './ParametreCompte.scss';

import { Edit} from '@mui/icons-material';
import {Button} from '@mui/material';
import {IconButton } from '@mui/material';
import Switch from '@mui/material/Switch';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import PasswordInput from '../../Components/Auth/PasswordInput';
import {buttonStyles, buttonStylesBlue, buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import DeleteAccount from '../../Components/shared/DeleteAccount';
import { IconTextField, TextFieldComponent } from '../../Components/shared/ReusableSmallComponents';
import AuthContext from '../../Contexts/AuthProvider';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useRole from '../../hooks/useRole';
import useWindowSize from '../../hooks/useWindowSize';
import { validatePassword } from '../../Utils/validationUtils';
function ParametreCompte() {
    const role=useRole();
    const { auth } = useContext(AuthContext);
    const axiosPrivate = useAxiosPrivate();

    const [is2FAChecked, setIs2FAChecked] = useState(false);
    const [oldPassword, setOldPassword] = useState();
    const [newPassword, setNewPassword] = useState('');
    const [repeatedPassword, setRepeatedPassword] = useState('');
    const [isPasswordShown, setPasswordShown] = useState(false);
    const [passwordError, setPasswordError] = useState();
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [isRepeatedPasswordShown, setisRepeatedPasswordShown] = useState(false);
    const label = { inputProps: { 'aria-label': 'Size switch demo' } };
    const [visibleEditPass,setVisibleEditPass]=useState(false);
    const [firstDataFromBackend,setFirstDataFromBackend]=useState();
    const [checkUpdateValue,setCheckUpdateValue]=useState(true);
    const { i18n } = useTranslation();
    const {device}=useWindowSize();

    useEffect(() => {
        if(role)
            getMyInfos();
    },[role]);

    useEffect(() => {
        validatePassword(newPassword, repeatedPassword,setPasswordError, setIsPasswordValid );
    }, [newPassword, repeatedPassword]);

    const togglePassword = () => {
        setPasswordShown(!isPasswordShown);
    };
    const toggleRepeatedPassword = () => {
        setisRepeatedPasswordShown(!isRepeatedPasswordShown);
    };

    const onSubmit = async () => {
        try {
            const response1 = await axiosPrivate.put('/users/switch2FA',
                { twoFA:is2FAChecked },
                {
                    headers:
                    {
                        'Content-Type': 'application/json'
                    },
                    withCredentials: true
                }
            );
            const responseData1 = await response1.data;
            // if(is2FAChecked)
            Swal.fire({
                icon: 'success',
                // title: '',
                text:  i18n.t(responseData1.message),
            });
            setVisibleEditPass(false);
        }catch (error) {
            console.log(error.response?.status);
        }
    };

    const updateMyPassword = async (e) => {
        e.preventDefault();
        try {
            const response1 = await axiosPrivate.put('/users/updateMyPassword',
                { oldPassword, newPassword },
            );
            const responseData1 = await response1.data;
            setVisibleEditPass(false);
            Swal.fire({
                icon: 'success',
                title: i18n.t('Mot de passe modifié avec succès'),
                text: '' + i18n.t(responseData1.message),
            });
        }catch (error) {
            console.log(error.response?.status);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: i18n.t(error.response.data?.error),
            });
        }
    };

    const toggleEditPass = () => {
        // if(role!='admin')
        setVisibleEditPass(!visibleEditPass);
    };

    const getMyInfos = async () => {
        try {
            const response = await axiosPrivate.get(`${role}/getMyInfos`);
            console.log('response.data',response.data);
            setFirstDataFromBackend(response.data);
            setIs2FAChecked(response?.data?.user?.twoFA);
        } catch (error) {
            console.log(error);
        }
    };

    const setInitialValue=()=>{
        if(firstDataFromBackend){
            setIs2FAChecked(firstDataFromBackend?.user?.twoFA);
            setCheckUpdateValue(true);
        }
    };

    return (
        <div className='frame000ParaCompte'>
            <div className='frame5Profile'>{i18n.t('Mon Compte')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}> {i18n.t('Paramètres de compte')} </span> </div>
            <div className='frame1CenterparaCompte'>
                <h4 className='titlesociete'>
                    {i18n.t('Paramètres de compte')}
                </h4>
                <div className='frame2paraCompte'>
                    <h6 className='titreframe2ParaCompte'>
                        {i18n.t('Informations de compte')}
                    </h6>
                    <div className='frame3box1paracompte'>
                        <div className='frame3B1paracompte'>
                            <TextFieldComponent
                                label={i18n.t('Prénom*')}
                                //InputLabelProps={{ shrink: true }}
                                autoComplete="off"
                                disabled
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px'},
                                }}
                                style={{width: '100%'}}
                                //InputProps={{ sx: { height: 48 } }}
                                size="medium"
                                value={auth?.prenom}
                                //InputProps={{ sx: { height: 48 } }}
                                //onChange={event => {
                                //    setIntitulePoste(event.target.value);
                                //}}
                                //ref={ref}
                            />
                        </div>
                        <div className='frame3B2paracompte'>
                            <TextFieldComponent
                                label={i18n.t('Nom')}
                                //InputLabelProps={{ shrink: true }}
                                disabled
                                autoComplete="off"
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px'},
                                }}
                                style={{width: '100%'}}
                                size="medium"
                                value={auth?.nom}
                                //InputProps={{ sx: { height: 48 } }}
                                //onChange={event => {
                                //    setIntitulePoste(event.target.value);
                                //}}
                                //ref={ref}
                            />
                        </div>
                    </div>
                    <div className='frame4box1paracompte'>
                        <div className='frame4B1paracompte'>
                            <TextFieldComponent
                                label={i18n.t('Email')}
                                //InputLabelProps={{ shrink: true }}
                                autoComplete="off"
                                disabled
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px'},
                                }}
                                style={{width: '100%'}}
                                size="medium"
                                value={auth?.email}
                            />
                        </div>
                    </div>
                    <div className='frame3B3paracompte'>
                        <div className='frame4B1paracompte'>
                            {!visibleEditPass ?
                                <IconTextField
                                    label={i18n.t('Mot de passe')}
                                    type="password"
                                    //disabled={role=='admin' ? true :false }
                                    value={'*********'}
                                    //InputLabelProps={{ shrink: true }}
                                    autoComplete="off"
                                    sx={{
                                        '& > :not(style)': { borderRadius: '8px'},
                                    }}
                                    style={{width: '100%'}}
                                    iconEnd={
                                        <IconButton
                                            onClick={toggleEditPass}
                                        >
                                            <Edit />
                                        </IconButton>
                                    }
                                />
                                :
                                <div className='frame4B2paracompte'>
                                    <IconTextField
                                        label={i18n.t('Saisissez l\'ancien mot de passe')}
                                        type="password"
                                        //InputLabelProps={{ shrink: true }}
                                        autoComplete="off"
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px'},
                                        }}
                                        style={{width: '100%'}}
                                        onChange={e => {
                                            setOldPassword(e.target.value);
                                        }}
                                        value={oldPassword}
                                    />
                                    <PasswordInput
                                        label={i18n.t('Nouveau mot de passe*')}
                                        variant="outlined"
                                        sx={{
                                            '& > :not(style)':
                                                {
                                                    borderRadius: '8px'},
                                        }}
                                        style={{width: '100%'}}
                                        isPasswordShown={isPasswordShown}
                                        togglePassword={togglePassword}
                                        password={newPassword}
                                        setPassword={setNewPassword}
                                        isPasswordValid={isPasswordValid}
                                        passwordError={passwordError}
                                    />
                                    <PasswordInput
                                        label={i18n.t('Confirmer le nouveau mot de passe*')}
                                        isConfirmationPassword={true}
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px'},
                                        }}
                                        style={{width: '100%'}}
                                        isPasswordShown={isRepeatedPasswordShown}
                                        togglePassword={toggleRepeatedPassword}
                                        password={repeatedPassword}
                                        setPassword={setRepeatedPassword}
                                        isPasswordValid={isPasswordValid}
                                        passwordError={passwordError}
                                    />
                                    <div style={{display: 'flex', justifyContent:'space-between',gap:device=='desktop'?'0px':'16px',width: '100%',flexDirection:device=='desktop'?'row':'column'}}>
                                        <Button
                                            variant="outlined"
                                            style={{...buttonStyles(),...{height:'50px',width:device=='desktop'? 'auto' :'100%'}}}
                                            onClick={toggleEditPass}
                                        >{i18n.t('Annuler')}</Button>
                                        <Button
                                            variant="contained"
                                            onClick={updateMyPassword}
                                            disabled={!isPasswordValid}
                                            style={{
                                                ...buttonStylesBlue(!isPasswordValid,'#214DCE'),...{width:device=='desktop'? 'auto' :'100%'}
                                            }}
                                        >{i18n.t('Enregistrer')}</Button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className='frame5paraCompte'>
                    <h6 className='titreframe5paracompte'>
                        {i18n.t('Politique d\'authentification 2-Factor')}
                    </h6>
                    <div className='frame6paracompte'>
                        <p className='titreframe6paracompte'>
                            {i18n.t('Activer l\'authentification 2-Factor')}
                        </p>
                        <div className='switchframe6paracompte'>
                            <Switch
                                {...label}
                                checked={is2FAChecked}
                                onChange={(event)=>{
                                    if(event.target.checked!=firstDataFromBackend?.user?.twoFA){
                                        setCheckUpdateValue(false);
                                    }
                                    setIs2FAChecked(event.target.checked);
                                }}
                            />
                        </div>
                    </div>
                    {/*masquer pour v1*/}
                    {/*<div className='frame7paracompte'>
                        <h6 className='titreframe5paracompte'>
                            Notifications
                        </h6>
                        <div className='frame8paracompte'>
                            <p
                                className='titreframe6paracompte'
                                style={{width:'700px'}}
                            >
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            </p>
                            <div className='switchframe6paracompte' >
                                <FormControlLabel
                                    value='on'
                                    control={<Switch {...label}  />}
                                />
                            </div>
                        </div>
                    </div>*/}
                    <div
                        className='frame10paracompte'
                        style={{justifyContent:(role!='admin')?'space-between':'flex-end'}}
                    >
                        {role!='admin' &&
                            <div className='Btn1paracompte'>
                                <DeleteAccount
                                    userEmail={auth.email}
                                    content={i18n.t('Supprimer le compte')}
                                    width='100%'
                                    //height='56px'
                                />
                            </div>
                        }
                        <div className='frame11paracompte'>
                            <div className='Btn2paracompte'>
                                <Button
                                    variant="text"
                                    style={{...buttonStyles(),...{width:device=='desktop'?'auto':'100%'}}}
                                    onClick={setInitialValue}
                                >
                                    {i18n.t('Annuler')}
                                </Button>
                            </div>
                            <div className='Btn3paracompte'>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    style={{...buttonStylesGreen(checkUpdateValue),...{width:device=='desktop'?'auto':'100%'}}}
                                    disabled={checkUpdateValue==true ? true : false}
                                    onClick={onSubmit}
                                >
                                    {i18n.t('Enregistrer')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ParametreCompte;